import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from '../../shared/reactSelect/select.component';

import HamburgerDropdown from '../shared/hamburgerDropdown.component';

import { selectReportingCurrencyCode, selectCompanyCodeIfExists } from '../../shared/store/actions';
import {
  periodsSelector,
  reportingCurrencyCodeSelector,
  companyCodeInContextSelector,
} from '../../shared/store/selectors';
import {
  selectCountryTaxType as selectCountryTaxTypeForBsm,
} from '../store/actions';

import {
  fetchSlGroupsInitialData,
  changeSlGroupTypeAndFetch,
  changeSlGroupItem,
  changePeriodFrom,
  changePeriodTo,
  changeCountryTaxType,
  changeTaxYear,
} from './store/actions';
import {
  selectPeriodFrom,
  selectPeriodTo,
  selectSlGroupTypes,
  selectSlGroupType,
  selectSlGroupItems,
  selectSlGroupItem,
  selectCountryTaxTypes,
  selectCountryTaxType,
  selectIsFetchingSlGroups,
  selectIsFetchingCountryTaxTypes,
  selectTaxYears,
  selectTaxYear,
  extraReportingCurrencyCodesForGroupSelector,
} from './store/selectors';

import {
  OptionPropTypes,
  PeriodPropTypes,
} from './propTypes';
import {
  COMPANY_CODE_TYPE_VALUE,
  COMPANY_CODE_TYPE,
  VIEW_TYPES,
  TAX_CURRENCY,
} from './constants';

class AggregationMenu extends PureComponent {
  static propTypes = {
    periods: PropTypes.arrayOf(PeriodPropTypes).isRequired,
    periodFrom: PeriodPropTypes,
    periodTo: PeriodPropTypes,

    slGroupTypes: PropTypes.arrayOf(OptionPropTypes).isRequired,
    slGroupType: OptionPropTypes,
    slGroupItems: PropTypes.arrayOf(OptionPropTypes).isRequired,
    slGroupItem: OptionPropTypes,
    companyCodeInContext: OptionPropTypes,
    isFetchingSlGroups: PropTypes.bool.isRequired,

    countryTaxTypes: PropTypes.arrayOf(OptionPropTypes).isRequired,
    countryTaxType: OptionPropTypes,
    isFetchingCountryTaxTypes: PropTypes.bool.isRequired,

    reportingCurrencyCode: PropTypes.string,
    reportingCurrencyCodes: PropTypes.arrayOf(OptionPropTypes).isRequired,

    fetchInitialData: PropTypes.func.isRequired,
    changeSlGroupType: PropTypes.func.isRequired,
    changeSlGroupItem: PropTypes.func.isRequired,
    selectCompanyCode: PropTypes.func.isRequired,
    changePeriodFrom: PropTypes.func.isRequired,
    changePeriodTo: PropTypes.func.isRequired,
    changeCountryTaxType: PropTypes.func.isRequired,
    selectCountryTaxTypeForBsm: PropTypes.func.isRequired,
    changeReportingCurrency: PropTypes.func.isRequired,

    taxYears: PropTypes.arrayOf(OptionPropTypes).isRequired,
    taxYear: OptionPropTypes,
    changeTaxYear: PropTypes.func.isRequired,

    withTaxYearSelector: PropTypes.bool,

    exportToExcel: PropTypes.func,
    exportToCsv: PropTypes.func,
    isExportingReport: PropTypes.bool,

    aggregationDropList: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string,
    }),

    includeFbosCTT: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    periodFrom: null,
    periodTo: null,
    slGroupType: null,
    slGroupItem: null,
    companyCodeInContext: null,
    countryTaxType: null,
    taxYear: null,
    withTaxYearSelector: false,
  };

  componentDidMount() {
    const {
      periodTo,
      companyCodeInContext,
      slGroupType,
      slGroupItem,
      fetchInitialData,
      includeFbosCTT,
    } = this.props;

    const periodName = periodTo && periodTo.name;
    if (!periodName) {
      return;
    }

    if (!slGroupItem && companyCodeInContext && periodName) {
      return fetchInitialData({
        periodName,
        slGroupType: COMPANY_CODE_TYPE,
        slGroupItem: companyCodeInContext,
        includeFbosCTT,
      });
    }

    if (slGroupType && slGroupType.value === COMPANY_CODE_TYPE_VALUE) {
      const companyCode = companyCodeInContext || slGroupItem;

      return fetchInitialData({ slGroupType, slGroupItem: companyCode, includeFbosCTT, periodName });
    }
    return fetchInitialData({ slGroupType, slGroupItem, includeFbosCTT, periodName });
  }

  onChangeSlGroupType = nextGroupType => {
    const { slGroupType, changeSlGroupType, periodTo } = this.props;

    const periodName = periodTo && periodTo.name;
    if (!periodName) {
      return;
    }

    if (!slGroupType || slGroupType.value !== nextGroupType.value) {
      if (periodName) {
        changeSlGroupType({ groupType: nextGroupType, periodName });
      }
    }
  };

  onChangeSlGroupItem = nextSlGroupItem => {
    const { slGroupType, slGroupItem, changeSlGroupItem, selectCompanyCode, periodTo } = this.props;

    if (!slGroupItem || slGroupItem.value !== nextSlGroupItem.value) {
      changeSlGroupItem(slGroupType, nextSlGroupItem, periodTo.name);
    }
    if (slGroupType.value === COMPANY_CODE_TYPE_VALUE) {
      selectCompanyCode(nextSlGroupItem.value);
    }
  };

  onChangePeriodFrom = nextPeriodFrom => {
    const { periodFrom, changePeriodFrom } = this.props;

    if (!periodFrom || periodFrom.value !== nextPeriodFrom.value) {
      changePeriodFrom(nextPeriodFrom);
    }
  };

  onChangePeriodTo = nextPeriodTo => {
    const { periodTo, changePeriodTo, slGroupType } = this.props;

    if (!periodTo || periodTo.value !== nextPeriodTo.value) {
      changePeriodTo({ periodTo: nextPeriodTo, groupType: slGroupType });
    }
  };

  onChangeCountryTaxType = nextCountryTaxType => {
    const { slGroupType, slGroupItem, countryTaxType, changeCountryTaxType, selectCountryTaxTypeForBsm } = this.props;

    if (!countryTaxType || countryTaxType.value !== nextCountryTaxType.value) {
      changeCountryTaxType(nextCountryTaxType, slGroupType, slGroupItem);
      if (slGroupType && slGroupType.value === COMPANY_CODE_TYPE_VALUE) {
        selectCountryTaxTypeForBsm(nextCountryTaxType);
      }
    }
  };

  onChangeReportingCurrency = nextCurrency => {
    const { changeReportingCurrency } = this.props;
    changeReportingCurrency(nextCurrency.value);
  };

  onChangeTaxYear = nextTaxYear => {
    const { taxYear, changeTaxYear } = this.props;

    if (!taxYear || taxYear.value !== nextTaxYear.value) {
      changeTaxYear(nextTaxYear);
    }
  };

  render() {
    const {
      periods,
      periodFrom,
      periodTo,
      slGroupTypes,
      slGroupType,
      slGroupItems,
      slGroupItem,
      isFetchingSlGroups,
      countryTaxTypes,
      countryTaxType,
      isFetchingCountryTaxTypes,
      reportingCurrencyCode,
      reportingCurrencyCodes,
      taxYears,
      taxYear,
      withTaxYearSelector,
      exportToExcel,
      exportToCsv,
      isExportingReport,
      aggregationDropList,
    } = this.props;

    return (
      <div className="aggregation-menu">
        <div className="aggregation-group">
          <div className="aggregation-selector">
            <div className="aggregation-label aggregation-label-sm">From</div>
            <Select
              className="select-period"
              clearable={false}
              labelKey="name"
              options={periods}
              value={periodFrom}
              onChange={this.onChangePeriodFrom}
              virtualized
            />
          </div>
          <div className="aggregation-selector">
            <div className="aggregation-label aggregation-label-sm">To</div>
            <Select
              className="select-period"
              clearable={false}
              labelKey="name"
              options={periods}
              value={periodTo}
              onChange={this.onChangePeriodTo}
              virtualized
            />
          </div>
          <div className="aggregation-selector">
            <div className="aggregation-label aggregation-label-md">Display by</div>
            <Select
              className="select-view-types-min"
              clearable={false}
              disabled={isFetchingSlGroups || !(periodTo && periodTo.value)}
              options={slGroupTypes}
              value={slGroupType}
              onChange={this.onChangeSlGroupType}
            />
          </div>
          <div className="aggregation-selector">
            <Select
              className="select-company-min"
              clearable={false}
              disabled={isFetchingSlGroups}
              options={slGroupItems}
              value={slGroupItem}
              onChange={this.onChangeSlGroupItem}
              virtualized
            />
          </div>
          { withTaxYearSelector
            ? (
              <div className="aggregation-selector">
                <div className="aggregation-label aggregation-label-md">Tax Year</div>
                <Select
                  className="select-tax-years"
                  clearable={false}
                  disabled={!taxYears || !taxYears.length}
                  options={taxYears}
                  value={taxYear}
                  onChange={this.onChangeTaxYear}
                />
              </div>
            ) : null
          }
          <div className="aggregation-selector">
            <Select
              className="select-country-tax-type-min"
              clearable={false}
              disabled={isFetchingCountryTaxTypes || isFetchingSlGroups || !slGroupItem}
              options={countryTaxTypes}
              value={countryTaxType}
              onChange={this.onChangeCountryTaxType}
              autoSelectFirstValue
              keepValueIfExistsInNewOptions
            />
          </div>
          <div className="aggregation-selector">
            <Select
              className="select-currency-min"
              clearable={false}
              disabled={isFetchingCountryTaxTypes}
              options={reportingCurrencyCodes}
              value={reportingCurrencyCode}
              onChange={this.onChangeReportingCurrency}
            />
          </div>

        </div>
        {aggregationDropList
          ? <Select
            className="view-by-dropdown select-view-by"
            clearable={false}
            name="viewType"
            options={VIEW_TYPES}
            onChange={aggregationDropList.onChange}
            value={aggregationDropList.value}
            scrollMenuIntoView={false}
            autoSelectFirstValue
            virtualized
          />
          : null
        }
        {exportToExcel || exportToCsv
          ? (
            <div className="hamburger-dropdown ml-auto text-right">
              <HamburgerDropdown
                exportToExcel={exportToExcel}
                exportToCsv={exportToCsv}
                isExportingReportForAllPills={isExportingReport}
              />
            </div>
          ) : null
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  periods: periodsSelector(state),
  periodFrom: selectPeriodFrom(state),
  periodTo: selectPeriodTo(state),
  slGroupTypes: selectSlGroupTypes(state),
  slGroupType: selectSlGroupType(state),
  slGroupItems: selectSlGroupItems(state),
  slGroupItem: selectSlGroupItem(state),
  isFetchingSlGroups: selectIsFetchingSlGroups(state),
  countryTaxTypes: selectCountryTaxTypes(state),
  countryTaxType: selectCountryTaxType(state),
  isFetchingCountryTaxTypes: selectIsFetchingCountryTaxTypes(state),
  reportingCurrencyCode: reportingCurrencyCodeSelector(state),
  reportingCurrencyCodes: extraReportingCurrencyCodesForGroupSelector([TAX_CURRENCY])(state),
  taxYears: selectTaxYears(state),
  taxYear: selectTaxYear(state),
  companyCodeInContext: companyCodeInContextSelector(state),
});

export default connect(
  mapStateToProps,
  {
    fetchInitialData: fetchSlGroupsInitialData,
    changeSlGroupType: changeSlGroupTypeAndFetch,
    changeSlGroupItem,
    selectCompanyCode: selectCompanyCodeIfExists,
    changePeriodFrom,
    changePeriodTo,
    changeCountryTaxType,
    selectCountryTaxTypeForBsm,
    changeReportingCurrency: selectReportingCurrencyCode,
    changeTaxYear,
  }
)(AggregationMenu);
